export default "__VITE_ASSET__CfRDITma__"